import { render, staticRenderFns } from "./addTime.vue?vue&type=template&id=1d5b7d65&scoped=true&"
import script from "./addTime.vue?vue&type=script&lang=js&"
export * from "./addTime.vue?vue&type=script&lang=js&"
import style0 from "./addTime.vue?vue&type=style&index=0&id=1d5b7d65&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b7d65",
  null
  
)

export default component.exports